<template>
  <f7-page :page-content="true" name="incidencias" @page:beforein="cargar">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title sliding :subtitle="$t('incidencias.subtitulo')">{{ $t('incidencias.titulo') }}</f7-nav-title>
    </f7-navbar>

    <f7-block v-if="error403" strong>
      <p>{{ $t('incidencias.noAutorizado') }}</p>
    </f7-block>

    <template v-else>
      <f7-block strong class="filtros no-margin-bottom">
        <div class="filtro-item">
          <label>{{ $t('incidencias.filtroEstado') }}:</label>
          <f7-segmented raised>
            <f7-button
              :fill="estadoFiltro == 'ABIERTA'"
              small
              @click="filtrarEstado('ABIERTA')"
            >{{ $t('incidencias.estado.ABIERTA') }}</f7-button>
            <f7-button
              :fill="estadoFiltro == 'RESUELTA'"
              small
              @click="filtrarEstado('RESUELTA')"
            >{{ $t('incidencias.estado.RESUELTA') }}</f7-button>
            <f7-button
              :fill="estadoFiltro == ''"
              small
              @click="filtrarEstado('')"
            >{{ $t('incidencias.todos') }}</f7-button>
          </f7-segmented>
        </div>
        <div class="filtro-item">
          <label>{{ $t('incidencias.filtroTipo') }}:</label>
          <select v-model="tipoFiltro" class="filtro-select" @change="cargar">
            <option value="">{{ $t('incidencias.todos') }}</option>
            <option v-for="t in tipos" :key="t" :value="t">{{ $t('incidencias.tipo.' + t) }}</option>
          </select>
        </div>
      </f7-block>

      <f7-block v-if="!incidencias.length" strong>
        <p>{{ $t('incidencias.sinIncidencias') }}</p>
      </f7-block>

      <f7-list v-else media-list no-hairlines class="lista-incidencias">
        <f7-list-item
          v-for="inc in incidencias"
          :key="inc.id"
          :title="$t('incidencias.tipo.' + inc.tipo)"
          :text="inc.descripcion"
        >
          <f7-badge slot="media" :color="colorSeveridad(inc.severidad)">
            {{ $t('incidencias.severidad.' + inc.severidad) }}
          </f7-badge>
          <div slot="footer">
            <span v-if="inc.contexto && inc.contexto.inspector">{{ $t('incidencias.inspector') }}: {{ inc.contexto.inspector }} · </span>
            <span v-if="inc.contexto && (inc.contexto.codigoPedido || inc.contexto.idExpediente)">{{ $t('incidencias.expediente') }}: {{ inc.contexto.codigoPedido || inc.contexto.idExpediente }} · </span>
            <span v-if="inc.contexto && inc.contexto.servicio">{{ $t('incidencias.servicio') }}: {{ inc.contexto.servicio }} · </span>
            <span>{{ $t('incidencias.fechaDeteccion') }}: {{ formatFecha(inc.fechaDeteccion) }}</span>
            <span v-if="inc.estado == 'RESUELTA' && inc.fechaResolucion"> · {{ $t('incidencias.fechaResolucion') }} {{ formatFecha(inc.fechaResolucion) }}</span>
          </div>
          <f7-button
            v-if="inc.estado == 'ABIERTA'"
            slot="after"
            fill
            small
            @click="resolver(inc.id)"
          >{{ $t('incidencias.resolver') }}</f7-button>
        </f7-list-item>
      </f7-list>
    </template>
  </f7-page>
</template>
<style scoped>
.filtros .filtro-item {
  display: inline-flex;
  align-items: center;
  margin-right: 24px;
  margin-bottom: 4px;
}
.filtros .filtro-item label {
  margin-right: 8px;
  font-weight: bold;
}
.filtro-select {
  padding: 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
}
.lista-incidencias .badge {
  padding: 3px 8px;
  height: auto;
}
</style>
<script>
import Incidencia from "./../../js/db/Incidencia.js";
import DateUtils from "./../../js/DateUtils.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";

export default {
  data: function() {
    return {
      incidencias: [],
      estadoFiltro: 'ABIERTA',
      tipoFiltro: '',
      tipos: ['SIN_COORDS', 'DIRECCION_INCOMPLETA', 'NO_RUTEABLE', 'GOOGLE_ERROR', 'MATRIZ_LIMITE'],
      error403: false
    };
  },
  methods: {
    colorSeveridad: function(severidad) {
      if (severidad == 'BLOQUEA_OPTIMIZACION') return 'red';
      if (severidad == 'AVISO') return 'orange';
      return 'gray';
    },
    formatFecha: function(fecha) {
      return fecha ? DateUtils.dateFormat(fecha, 'DD/MM/YYYY HH:mm') : '';
    },
    es403: function(e) {
      return !!(e && (e.status == 403 || (e.xhr && e.xhr.status == 403)));
    },
    tratarError: function(e) {
      var self = this;
      var app = self.$f7;
      if (self.es403(e)) {
        self.error403 = true;
      } else {
        app.dialog.alert(e && e.message ? e.message : self.$t('searchBarSinResultados'));
      }
    },
    filtrarEstado: function(estado) {
      var self = this;
      self.estadoFiltro = estado;
      self.cargar();
    },
    cargar: function() {
      var self = this;
      Incidencia.listar(self.estadoFiltro, self.tipoFiltro)
        .then(function(res) {
          self.incidencias = res || [];
        })
        .catch(function(e) {
          self.tratarError(e);
        });
    },
    resolver: function(id) {
      var self = this;
      var app = self.$f7;
      // #663 · La espera de la sesión: si la sesión cambia en vuelo, la frontera calla el `then` que la apagaba.
      const espera = preloaderDeLaSesion(self);
      espera.mostrar();
      Incidencia.resolver(id)
        .then(function() {
          app.toast
            .create({
              text: self.$t('incidencias.resuelta'),
              position: 'center',
              closeTimeout: 2000,
              icon: '<i class="f7-icons">checkmark_alt</i>'
            })
            .open();
          self.cargar();
        })
        .catch(function(e) {
          self.tratarError(e);
        })
        .then(function() {
          espera.cerrar();
        });
    }
  }
};
</script>
